import { mutatorAction } from "satcheljs";
import type { AccountKey } from "owa-client-types";
import { OcpsPoliciesFetchState } from "../store/schema/OutlookCloudPoliciesSchema";
import type { AccountOcpsPoliciesState } from "../store/schema/OutlookCloudPoliciesSchema";
import getStore from "../store/store";

export const setAccountPoliciesMutator: (accountKey: AccountKey, policies: AccountOcpsPoliciesState["policies"]) => void = mutatorAction("setAccountPolicies", (accountKey: AccountKey, policies: AccountOcpsPoliciesState["policies"]): void => {
    const existing = getStore().get(accountKey);
    if (existing) {
        existing.policies = policies;
    }
    else {
        getStore().set(accountKey, { policies, fetchState: OcpsPoliciesFetchState.Succeeded });
    }
});
